var exports = {
  "wrap": "x936d19a0--e15860--wrap",
  "star": "x936d19a0--e15860--star",
  "star-size_s": "x936d19a0--e15860--star-size_s",
  "star-size_m": "x936d19a0--e15860--star-size_m",
};

module.exports = exports;
